import Menu from "components/common/Menu";
import CreateStaffForm from "components/form/CreateStaffForm";
import { SideBarTabs } from "constants/tabs";
import AppCopy from "copy/AppCopy";
import { CreateStaffFormSubmit } from "declarations/form";
import useAdminOnly from "hook/useAdminOnly";
import { useTabActive } from "hook/useTabActive";
import useUser from "hook/useUser";
import React from "react";
import { CommonStyles } from "styles/CommonStyles";
import PageHeader from "components/common/PageHeader";

function CreateStaffPage() {
  const { registerStaff } = useUser();

  useAdminOnly();

  useTabActive(SideBarTabs.Staff.name);

  const handleRegister = async ({
    email,
    name,
    password,
    phone,
  }: CreateStaffFormSubmit) => {
    await registerStaff({ email, name, password, phoneNumber: phone });
  };

  const { titleText } = AppCopy.createStaffPage;

  return (
    <div className={`${CommonStyles.pageWrapper}`}>
      <Menu />
      <PageHeader
        title={titleText}
        description="Create a staff account with dashboard access."
      />
      <div className={ClassName.container}>
        <div className={ClassName.formContainer}>
          <CreateStaffForm onSubmit={handleRegister} />
        </div>
      </div>
    </div>
  );
}

export default CreateStaffPage;

const ClassName = {
  container: "flex flex-1 items-start justify-center",
  formContainer:
    "flex w-full max-w-lg flex-col rounded-2xl border border-slate-200 bg-white p-5 sm:p-7",
};
